import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setAuthToken } from "../lib/api-client";

const TOKEN_KEY = "rm_auth_token";

/**
 * AuthCallback - Receives redirect from external login (landing page)
 * Reads token from URL hash (fallback for browsers blocking third-party cookies)
 * and stores it for Bearer auth. Then redirects to dashboard.
 */
export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // Try to read token from URL hash (e.g., #token=xxx)
    const hash = window.location.hash;
    if (hash) {
      const params = new URLSearchParams(hash.substring(1));
      const token = params.get("token");
      if (token) {
        setAuthToken(token);
        sessionStorage.setItem(TOKEN_KEY, token);
        // Clean the hash from URL for security (token shouldn't stay visible)
        window.history.replaceState(null, "", window.location.pathname);
      }
    }

    // Redirect to dashboard — AuthContext will fetch user from /me
    navigate("/", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Iniciando sesión...</p>
      </div>
    </div>
  );
}
